var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'more pr cp oh cr-white ' + _vm.innerClass,style:(_vm.innerStyle),attrs:{"data-name":_vm.name},on:{"click":_vm.on_click}},[_c('div',{staticClass:"line ani pa bg-primary ht-auto"}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-c lh-40"},[_vm._v(" 查看更多 "),_c('span',{staticClass:"pa arrow icon-youjiantou iconfont txt-size-12 arrow_act"})])
}]

export { render, staticRenderFns }